export default __webpack_public_path__ + "static/media/linea-blanca.d982cb09.svg";